import { computed, makeObservable, observable } from "mobx";
import { atom } from "../atom";
import { Action, ActionMeta, Canvas } from "../Types";
import { canvasReducer } from "./CanvasReducer";

export type SocketState = "connected" | "connecting" | "disconnected";
export const socketStateAtom = atom<SocketState>("disconnected");
const EMPTY_CANVAS: Canvas = {
  id: "",
  name: "",
  panes: [],
  layouts: [],
  createdTime: Date.now(),
};

class ApplicationState {
  server: [canvas: Canvas, version: number] | undefined = undefined;
  clientId: number | undefined = undefined;
  lastActionId: number | undefined = undefined;
  localActions: [Action, ActionMeta][] = [];

  constructor() {
    makeObservable(this, {
      server: observable.ref,
      clientId: observable,
      lastActionId: observable,
      localActions: observable.ref,
      canvas: computed,
    });
  }

  get canvas(): Canvas {
    if (applicationState.server === undefined) {
      return EMPTY_CANVAS;
    }
    return applicationState.localActions.reduce(
      (canvas, [action]) => canvasReducer(canvas, action),
      applicationState.server[0]
    );
  }
}

export const applicationState = new ApplicationState();
